import Common from '@/utils/saas/common' // 工具类
import saas from '@/utils/saas'

// 一些常用方法
// 数据为空时设置为null
export function setNull(obj) {
  for (const i in obj) {
    if (obj[i] === '' || JSON.stringify(obj[i]) === '[]') {
      obj[i] = null
    }
  }
  return obj
}

// 查询城市接口列表
export function getArea(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'AREA_SELECT', data, '地区查询')
}
